import { createTheme } from '@mui/material';

export const customMaterialTheme = createTheme({
    palette: {
        warning: {
            main: '#ec971f',
            contrastText: '#ffffff'
        },
        error: {
            main: '#db3232'
        },
        success: {
            main: '#599a35'
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'capitalize'
                }
            }
        },
        MuiIcon: {
            defaultProps: {
                fontSize: 'inherit'
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                input: {
                    '&:-webkit-autofill': {
                        WebkitBoxShadow: '0 0 0px 1000px #fefefe inset' // Force white background
                    },
                    backgroundColor: '#fefefe',
                    borderRadius: '4px'
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: { backgroundColor: '#fefefe' }
            }
        }
    }
});
